import { batch } from 'react-redux';

const isActiveList = (listItem, activeItemKey) => {
    if(listItem.key === activeItemKey) {
        return true;
    } else if(listItem.children) {
        return listItem.children.some(child => isActiveList(child, activeItemKey));
    } else {
        return false;
    }
}

export const templateWellsModel = {
    name: 'templateWells',
    state: {
        /*
            Массив keys выбранных скважин
        */
        wellsKeys: [],
        /*
            Массив скважин (key, id, title). Нужен для отображения в списке.
        */
        wells: [],
        /*
            Набор скважин, к которым был применен выбранный шаблон.
            Вид: { [wellKey]: templateId }
        */
        currentWellsTemplateId: {},
    },
    reducers: {
        setCurrentWellsTemplateId(state, templateId) {
            const { wellsKeys, currentWellsTemplateId } = state;

            const templatesIdsByWells = wellsKeys.reduce((acc, wellKey) => {
                acc[wellKey] = templateId;
                return acc;
            }, {});

            const updatedCurrentWellsTemplateId = Object.assign({}, currentWellsTemplateId, templatesIdsByWells);

            return { ...state, currentWellsTemplateId: updatedCurrentWellsTemplateId };
        },
        setWellsKeys(state, keys) {
            return { ...state, wellsKeys: keys };
        },
        setWells(state, payload) {
            return { ...state, wells: payload };
        },
    },
    effects: {
        /*
            Метод инициализирует state значениями для отрисовки из модели List.
        */
        async init() {
            const selectedWells = await this._getWellsFromList();
            
            const wells = selectedWells.filter(well => well).map(well => ({ id: well.id, key: well.key, title: well.title }));
            const wellsKeys = wells.map(well => well.key);

            batch(() => {
                this.setWellsKeys(wellsKeys);
                this.setWells(wells);
            });
        },
        /*
            Возвращает скважины, которые активны для отображения на данный момент в виде СПИСКА
        */
        async _getWellsFromList(_, rootState) {
            const list = rootState.lists.data;
            
            const activeItemKey = rootState.lists.activeItemKey;
            /*
                Поиск выбранной node в List. Это может быть как группа так и отдельный элемент.
            */
            const wellsList = list.find(listItem => isActiveList(listItem, activeItemKey));
            /*
                Если node имеет свойство children - это группа.
            */
            const wells = wellsList?.children ? wellsList.children : [wellsList];

            return wells;
        },
    },
};
